import { AWSAppSyncClient } from 'aws-appsync';
import Amplify from '@aws-amplify/core';
import Auth from '@aws-amplify/auth';
import { AUTH_TYPE } from 'aws-appsync/lib/link/auth-link';
import { AppSyncConfig } from './config';

Amplify.configure({
  Auth: {
    // identityPoolId: AppSyncConfig.identityPoolId,
    region: AppSyncConfig.region,
    userPoolId: AppSyncConfig.userPoolId,
    userPoolWebClientId: AppSyncConfig.userPoolWebClientId
  }
});

export const ApiClient = new AWSAppSyncClient({
  url: AppSyncConfig.graphqlEndpoint,
  region: AppSyncConfig.region,
  auth: {
    type: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
    jwtToken: async () => {
      try {
        const session = await Auth.currentSession();
        return session.getIdToken().getJwtToken();
      } catch (e) {
        // No current user - return null (user not logged in yet)
        return null;
      }
    }
  },
  disableOffline: true
});
